/*
 * IMPORTS
 */
import React from "react"; // Npm: react.js library.
import PropTypes from "prop-types"; // Npm: React prop types.
import { toast } from "react-hot-toast"; // Npm: Toast notifications.
import { useMutation } from "@apollo/client"; // Npm: Apollo client.
import { connect } from "react-redux"; // Npm: React Redux.

/*
 * PACKAGES
 */
import DeleteCard from "components/DeleteCard";

/*
 * GRAPHS
 */
import ScriptDeleteMutation from "./__mutation__/index.script.delete.mutation";

/*
 * OBJECTS
 */
const Index = ({ passOn, onClose, refetch }) => {
  // Const assignment.
  const _successFlags = React.useMemo(
    () =>
      Object.React.App.enums.GRAPHQL_SUCCESSFUL_QUERY_FLAGS.enums.map(
        (i) => i.key,
      ),
    [],
  );

  // Hook assignment.
  const [MutationScriptDelete, MutationScriptDeleteResponse] = useMutation(
    ScriptDeleteMutation,
  );

  // Return component.
  return (
    <DeleteCard
      subHeading={`This will permanently delete ${
        passOn?.scriptName || "the selected PDU script"
      }.`}
      onClose={onClose}
      disabled={MutationScriptDeleteResponse.loading}
      isLoading={MutationScriptDeleteResponse.loading}
      onConfirm={() =>
        MutationScriptDelete({
          variables: { scriptId: passOn?.scriptId },
        })
          .then(async (response) => {
            const _deletedScript = response?.data?.ScriptDelete;

            toast(_deletedScript?.message);

            if (!_successFlags.includes(_deletedScript?.status))
              return void 0;

            await refetch?.();
            return onClose?.();
          })
          .catch((caughtError) =>
            toast(
              caughtError?.message ||
                "Something went wrong please try after some time.",
            ),
          )
      }
    />
  );
};

/*
 * PROPTYPES
 */
Index.propTypes = {
  passOn: PropTypes.object,
  onClose: PropTypes.func,
  refetch: PropTypes.func,
};

/*
 * REDUX
 */
const _MapStateToProps = (__state) => ({ passOn: __state.PassOn });

/*
 * EXPORT
 */
export default connect(_MapStateToProps)(Index);
